module.exports = __webpack_public_path__ + "static/media/appetizers.0735a00f.svg";